import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Activity, RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [topics, setTopics] = useState([]);
  const [topic, setTopic] = useState("all");

  const load = () => {
    const q = topic === "all" ? "" : `?topic=${topic}`;
    api.get(`/events${q}`).then((r) => { setEvents(r.data.events); setTopics(r.data.topics); });
  };
  useEffect(() => { load(); }, [topic]);

  return (
    <div className="p-8 space-y-6" data-testid="events-page">
      <div className="border-b border-[var(--border)] pb-5 flex items-end justify-between">
        <div>
          <div className="label-mono mb-2">EVENT BUS</div>
          <h1 className="font-display font-black text-4xl tracking-tight">Eventos</h1>
          <p className="text-sm text-[var(--text-dim)] mt-1">
            Flujo en tiempo real de eventos del sistema (leads, deals, seguridad, aprobaciones).
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Select value={topic} onValueChange={setTopic}>
            <SelectTrigger className="w-64 rounded-none bg-[var(--surface)] border-[var(--border)] font-mono text-xs" data-testid="ev-topic">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="rounded-none bg-[var(--surface)] border-[var(--border)]">
              <SelectItem value="all">Todos los topics</SelectItem>
              {topics.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button onClick={load} variant="outline" className="rounded-none border-[var(--border)]" data-testid="ev-refresh">
            <RefreshCcw className="w-3 h-3" />
          </Button>
        </div>
      </div>

      {events.length === 0 ? (
        <div className="border border-dashed border-[var(--border)] p-12 text-center" data-testid="ev-empty">
          <Activity className="w-6 h-6 mx-auto text-[var(--text-dim)] mb-2" />
          <p className="text-sm text-[var(--text-dim)]">Sin eventos con este filtro.</p>
        </div>
      ) : (
        <div className="border border-[var(--border)] bg-[var(--surface)] font-mono text-xs">
          {events.map((e) => (
            <div key={e.id} className="flex items-start gap-4 py-2 px-4 border-b border-[var(--border)] last:border-0 hover:bg-[var(--surface-2)]/40" data-testid={`ev-${e.id}`}>
              <div className="text-[var(--text-dim)] shrink-0 w-40">
                {new Date(e.timestamp).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
                <span className="opacity-60 ml-1">{new Date(e.timestamp).toLocaleDateString("es-ES")}</span>
              </div>
              <div className="w-56 shrink-0">
                <Badge className="rounded-none bg-[var(--accent)]/10 text-[var(--accent)] border border-[var(--accent)]/40 font-mono text-[10px]">
                  {e.topic}
                </Badge>
              </div>
              <div className="flex-1 text-[var(--text-dim)] truncate">
                {JSON.stringify(e.payload)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
